let actions = {};

// This one is unique because there is no AnalyticsStore. It's just called as Framework.actions.collectAnalytics()
actions.collectAnalytics = (object) => {
	window.ef.analyticsService.collectAnalytics(object);
};

// This file is at the center of issues that can cause circular dependencies and
// unit test failure. In short, if anything imported in this file, or it's
// children/grandchildren imports 'Framework', the problem occurs because
// Framework imports this file. Gotta love SystemJS / JSPM!

// The strategy being used to avoid circular dependencies is:
// 1) Don't import anything else in this file
// 2) Add stubs for actions that are implemented in non-Reflux portions of Stores (just to satisfy the unit tests)
// 3) Overwrite those stubs by initializing these actions properly in
//    `/src/components/main` to support code in other projects that use
//    `window.LtFramework.actions.someActionName()`.
//    NOTE: The stubs below should be replaced before they are called...

// But alert us quickly if they are called somehow.
function devError(actionName) {
	// If this executes then something called an action before /src/components/main->run() ran. Impossible?
	throw new Error('Development Error: ' + actionName + ' was called before it was wired to the real implementation.');
}

// Stubs

// ClubStore
actions.updateClub = () => devError('updateClub');

// UrlStore
actions.urlUpdated = () => devError('urlUpdated');
actions.updateUrl = () => devError('updateUrl');
actions.bindPartnerUrls = () => devError('bindPartnerUrls');

// ProspectProfileStore
actions.updateProspectClub = () => devError('updateProspectClub');

// nearestClubStore
actions.searchForNearestClub = () => devError('searchForNearestClub');

// AlertNotificationStore
actions.createSuccessNotification = () => devError('createSuccessNotification');
actions.createInfoNotification = () => devError('createInfoNotification');
actions.createWarningNotification = () => devError('createWarningNotification');
actions.createDangerNotification = () => devError('createDangerNotification');
actions.closeNotification = () => devError('closeNotification');

export default actions;
